<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" [dir]="isAr ? 'rtl' : 'ltr'">
  <div class="bb-page-shell">
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                                 <span class="bb-eyebrow">{{ 'add order' | transloco }}</span>
        <h2 class="bb-page-title">{{ "add order" | transloco }}</h2>
      </div>
    </div>

    <form class="bb-card bb-p-20" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="bb-form-grid">
        @if(submitted && (data.invalid || hasNoSelectedItems())) {
        <div class="bb-form-alert bb-field-full" role="alert">
          {{ 'Review order data before saving' | transloco }}
          @if(getMissingRequiredCount() > 0) {
          <span>
            ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
          </span>
          }
        </div>
        }

        <!-- Product Selection -->
        <div
          #productSelectWrap
          class="bb-field bb-field-full bb-chip-select"
          *ngIf="canSelectProducts && warehouseTypeService.canShowProducts()"
        >
          <label class="bb-label bb-chip-label">{{ "select product" | transloco }}</label>

          <mat-form-field class="bb-chip-mat-field" appearance="outline">
            <mat-chip-grid #chipGrid class="bb-chip-grid-custom">
              <mat-chip-row
                *ngFor="let item of selectedProductsDetails; trackBy: trackByProduct"
                (removed)="removeProduct(item.product.id)"
                class="bb-chip-item bb-chip-item-product"
              >
                {{ getProductDisplayName(item.product) }}

                <button matChipRemove type="button" class="bb-chip-remove-btn">
                  ×
                </button>
              </mat-chip-row>

              <input
                #productInput
                class="bb-chip-input"
                matInput
                placeholder="{{ 'Search By product name' | transloco }}"
                [value]="searchValue"
                (input)="onSearchChange($event)"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>

        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="addProduct($event)"
          class="bb-chip-autocomplete-panel"
        >
          <mat-option *ngFor="let product of filteredProviders" [value]="product">
            {{ getProductDisplayName(product) }} -
            {{ 'price' | transloco }}:
            {{ product.pricea }}
            {{ 'egp' | transloco }}
          </mat-option>
        </mat-autocomplete>

        <!-- Service Selection -->
        <div
          #serviceSelectWrap
          class="bb-field bb-field-full bb-chip-select"
          *ngIf="canSelectServices && warehouseTypeService.canShowServices()"
        >
          <label class="bb-label bb-chip-label">{{ "select service" | transloco }}</label>

          <mat-form-field class="bb-chip-mat-field" appearance="outline">
            <mat-chip-grid #serviceChipGrid class="bb-chip-grid-custom">
              <mat-chip-row
                *ngFor="let item of selectedServicesDetails; trackBy: trackByService"
                (removed)="removeService(item.service.id)"
                class="bb-chip-item bb-chip-item-service"
              >
                {{ getServiceDisplayName(item.service) }}

                <button matChipRemove type="button" class="bb-chip-remove-btn">
                  ×
                </button>
              </mat-chip-row>

              <input
                #serviceInput
                class="bb-chip-input"
                matInput
                placeholder="{{ 'Search By service name' | transloco }}"
                [value]="serviceSearchValue"
                (input)="onServiceSearchChange($event)"
                [matAutocomplete]="serviceAuto"
                [matChipInputFor]="serviceChipGrid"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>

        <mat-autocomplete
          #serviceAuto="matAutocomplete"
          (optionSelected)="addService($event)"
          class="bb-chip-autocomplete-panel"
        >
          <mat-option *ngFor="let service of filteredServices" [value]="service">
            {{ getServiceDisplayName(service) }} -
            {{ 'price' | transloco }}:
            {{ service.pricea }}
            {{ 'egp' | transloco }}
          </mat-option>
        </mat-autocomplete>

        @if(shouldShowItemsError()) {
        <div class="bb-field-error bb-field-full">
          {{ 'Select at least one product or service' | transloco }}
        </div>
        }

        <!-- Clear Client Button -->
        <div class="bb-field bb-field-full" *ngIf="clearClientBtn">
          <button (click)="clearClient()" class="bb-btn bb-btn-secondary" role="button">
            {{ 'clear client' | transloco }}
          </button>
        </div>

        <!-- Client Information -->
        <div class="bb-field">
          <label class="bb-label" for="client_name">{{ 'client name' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="client_name"
            formControlName="client_name"
            placeholder="{{ 'client name' | transloco }}"
            [(ngModel)]="client_name"
            [ngClass]="{
              'is-invalid': data.get('client_name')?.touched && data.get('client_name')?.invalid,
              'is-valid': data.get('client_name')?.touched && data.get('client_name')?.valid
            }"
          />
          @if(shouldShowError('client_name')) {
          <div class="bb-field-error">{{ getErrorMessage('client_name', ('client name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="phone_number">{{ 'Phone Number' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="phone_number"
            formControlName="phone_number"
            placeholder="{{ 'Phone Number' | transloco }}"
            [(ngModel)]="phone_number"
            [ngClass]="{
              'is-invalid': data.controls['phone_number'].touched && data.controls['phone_number'].errors,
              'is-valid': data.controls['phone_number'].touched && !data.controls['phone_number'].errors,
              'is-touched': data.controls['phone_number'].untouched && !data.controls['phone_number'].errors,
            }"
          />
          @if(shouldShowError('phone_number')) {
          <div class="bb-field-error">{{ getErrorMessage('phone_number', ('Phone Number' | transloco)) }}</div>
          }
          @if(clientLookupLoading) {
          <div class="bb-field-hint">{{ 'Searching for client...' | transloco }}</div>
          }
          @if(clientLookupMessage) {
          <div class="bb-field-hint bb-field-hint-success">{{ clientLookupMessage }}</div>
          }
        </div>

        <!-- Delivery Information -->
        <ng-container *ngIf="hasDelivery">
          <div class="bb-field bb-field-full">
            <label class="bb-label" for="another_phone">{{ 'Another Phone Number' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="another_phone"
              formControlName="another_phone"
              placeholder="{{ 'Another Phone Number' | transloco }}"
              [(ngModel)]="another_phone"
              [ngClass]="{
                'is-invalid': data.get('another_phone')?.touched && data.get('another_phone')?.invalid,
                'is-valid': data.get('another_phone')?.touched && data.get('another_phone')?.valid
              }"
            />
            @if(shouldShowError('another_phone')) {
            <div class="bb-field-error">{{ getErrorMessage('another_phone', ('Another Phone Number' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="building_number">{{ 'Building number' | transloco }}</label>
            <input
              class="bb-input"
              id="building_number"
              formControlName="building_number"
              [placeholder]="'Building number' | transloco"
              [(ngModel)]="building_number"
              [ngClass]="{
                'is-invalid': data.get('building_number')?.touched && data.get('building_number')?.invalid,
                'is-valid': data.get('building_number')?.touched && data.get('building_number')?.valid
              }"
            />
            @if(shouldShowError('building_number')) {
            <div class="bb-field-error">{{ getErrorMessage('building_number', ('Building number' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="street">{{ 'Street' | transloco }}</label>
            <input
              class="bb-input"
              id="street"
              formControlName="street"
              [placeholder]="'Street' | transloco"
              [(ngModel)]="street"
              [ngClass]="{
                'is-invalid': data.get('street')?.touched && data.get('street')?.invalid,
                'is-valid': data.get('street')?.touched && data.get('street')?.valid
              }"
            />
            @if(shouldShowError('street')) {
            <div class="bb-field-error">{{ getErrorMessage('street', ('Street' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="landmark">{{ 'Landmark' | transloco }}</label>
            <input
              class="bb-input"
              id="landmark"
              formControlName="landmark"
              [placeholder]="'Landmark' | transloco"
              [(ngModel)]="landmark"
              [ngClass]="{
                'is-invalid': data.get('landmark')?.touched && data.get('landmark')?.invalid,
                'is-valid': data.get('landmark')?.touched && data.get('landmark')?.valid
              }"
            />
            @if(shouldShowError('landmark')) {
            <div class="bb-field-error">{{ getErrorMessage('landmark', ('Landmark' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="floor">{{ 'Floor' | transloco }}</label>
            <input
              class="bb-input"
              id="floor"
              formControlName="floor"
              [placeholder]="'Floor' | transloco"
              [(ngModel)]="floor"
              [ngClass]="{
                'is-invalid': data.get('floor')?.touched && data.get('floor')?.invalid,
                'is-valid': data.get('floor')?.touched && data.get('floor')?.valid
              }"
            />
            @if(shouldShowError('floor')) {
            <div class="bb-field-error">{{ getErrorMessage('floor', ('Floor' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="home">{{ 'Apartment' | transloco }}</label>
            <input
              class="bb-input"
              id="home"
              formControlName="home"
              [placeholder]="'Apartment' | transloco"
              [(ngModel)]="home"
              [ngClass]="{
                'is-invalid': data.get('home')?.touched && data.get('home')?.invalid,
                'is-valid': data.get('home')?.touched && data.get('home')?.valid
              }"
            />
            @if(shouldShowError('home')) {
            <div class="bb-field-error">{{ getErrorMessage('home', ('Apartment' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="delivery_fees">{{ 'delivery fees' | transloco }}</label>
            <input
              class="bb-input"
              type="number"
              id="delivery_fees"
              formControlName="delivery_fees"
              placeholder="{{ 'delivery fees' | transloco }}"
              [(ngModel)]="delivery_fees"
              [ngClass]="{
                'is-invalid': data.get('delivery_fees')?.touched && data.get('delivery_fees')?.invalid,
                'is-valid': data.get('delivery_fees')?.touched && data.get('delivery_fees')?.valid
              }"
            />
            @if(shouldShowError('delivery_fees')) {
            <div class="bb-field-error">{{ getErrorMessage('delivery_fees', ('delivery fees' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label">{{ "Select Governorate" | transloco }}</label>
            <div class="bb-select-wrap">
              <select
                class="bb-select"
                formControlName="government_id"
                [(ngModel)]="government_id"
                (change)="loadCities($event)"
                [ngClass]="{
                  'is-invalid': data.get('government_id')?.touched && data.get('government_id')?.invalid,
                  'is-valid': data.get('government_id')?.touched && data.get('government_id')?.valid
                }"
              >
                <option value="">{{ "Select Governorate" | transloco }}</option>
                <option *ngFor="let gov of governorates" [value]="gov.id">
                  {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
                </option>
              </select>
            </div>
            @if(shouldShowError('government_id')) {
            <div class="bb-field-error">{{ getErrorMessage('government_id', ('Select Governorate' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label">{{ "Select area" | transloco }}</label>
            <div class="bb-select-wrap">
              <select
                class="bb-select"
                formControlName="city_id"
                [(ngModel)]="city_id"
                [ngClass]="{
                  'is-invalid': data.get('city_id')?.touched && data.get('city_id')?.invalid,
                  'is-valid': data.get('city_id')?.touched && data.get('city_id')?.valid
                }"
              >
                <option value="">{{ "Select area" | transloco }}</option>
                <option *ngFor="let city of cities" [value]="city.id">
                  {{ isAr ? city.city_name_ar : city.city_name_en }}
                </option>
              </select>
            </div>
            @if(shouldShowError('city_id')) {
            <div class="bb-field-error">{{ getErrorMessage('city_id', ('Select area' | transloco)) }}</div>
            }
          </div>
        </ng-container>

        <!-- Note -->
        <div class="bb-field bb-field-full">
          <label class="bb-label" for="note">{{ 'note' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="note"
            formControlName="note"
            placeholder="{{ 'note' | transloco }}"
            [(ngModel)]="note"
            [ngClass]="{
              'is-invalid': data.controls['note'].touched && data.controls['note'].errors,
              'is-valid': data.controls['note'].touched && !data.controls['note'].errors,
              'is-touched': data.controls['note'].untouched && !data.controls['note'].errors,
            }"
          />
        </div>

        <!-- Create Order By User (Admin Only) -->
        @if(showAllUsers && showCreateByUserField){
        <div class="bb-field bb-field-full">
          <label class="bb-label" for="createby">{{ 'create this order by' | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              id="createby"
              class="bb-select"
              (ngModelChange)="onitemchange($event)"
              formControlName="createby"
              [ngClass]="{
                'is-invalid': data.get('createby')?.touched && data.get('createby')?.invalid,
                'is-valid': data.get('createby')?.touched && data.get('createby')?.valid
              }"
            >
              <option value="" disabled selected>{{ 'select' | transloco }}</option>
              @for (user of users; track user) {
              <option [value]="user.id +'type'+ user.type">{{user.last_name}}</option>
              }
            </select>
          </div>
          @if(shouldShowError('createby')) {
          <div class="bb-field-error">{{ getErrorMessage('createby', ('create this order by' | transloco)) }}</div>
          }
        </div>
        }

        <!-- Update Mode: Selected Products Summary -->
        @if(isUpdate){
        <div class="bb-field bb-field-full">
          <label class="bb-label">{{ 'Selected Items' | transloco }}</label>

          <div *ngFor="let item of selectedProductsDetails" class="bb-card bb-p-16 bb-mb-12">
            <div class="bb-text-stack">
              <p class="bb-m-0 bb-font-bold">
                <strong>{{ 'Product' | transloco }}:</strong> {{ getProductDisplayName(item.product) }}
              </p>

              <label class="bb-label">
                <strong>{{ 'quantity' | transloco }}:</strong>
                <input
                  type="number"
                  class="bb-input bb-mt-8"
                  [(ngModel)]="item.quantity"
                  min="1"
                  name="quantity{{item.product.id}}"
                />
              </label>

              <p class="bb-m-0 bb-price">
                <strong>{{ 'price' | transloco }}:</strong> {{ item.price }} {{ 'جنيه' | transloco }}
              </p>
            </div>
          </div>
        </div>
        }
        @else{
        <!-- Normal Mode: Services Table -->
        <div class="bb-field bb-field-full" *ngIf="selectedServicesDetails.length > 0">
          <label class="bb-label">{{ 'Services' | transloco }}</label>

          <div class="bb-table-scroll">
            <table class="bb-table">
              <thead>
                <tr>
                  <th class="mat-header-cell-custom">{{ 'service name' | transloco }}</th>
                  <th class="mat-header-cell-custom" *ngIf="!isMobile">{{ 'quantity' | transloco }}</th>
                  <th class="mat-header-cell-custom">{{ 'price' | transloco }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of selectedServicesDetails">
                  @if(isMobile){
                  <td class="mat-cell-custom">
                    <div class="bb-text-stack">
                      <div class="bb-product-title">
                        {{ 'Service' | transloco }} - {{ getServiceDisplayName(item.service) }}
                      </div>

                      <div class="bb-grid bb-gap-8">
                        <input
                          type="number"
                          class="bb-input"
                          placeholder="{{ 'quantity' | transloco }}"
                          min="1"
                          [(ngModel)]="item.quantity"
                          [ngModelOptions]="{standalone: true}"
                        />

                        <input
                          class="bb-input"
                          type="number"
                          min="0"
                          placeholder="{{ 'price' | transloco }}"
                          [(ngModel)]="item.price"
                          [ngModelOptions]="{standalone: true}"
                        />
                      </div>
                    </div>
                  </td>
                  } @else {
                  <td class="mat-cell-custom bb-font-bold">
                    {{ 'Service' | transloco }} - {{ getServiceDisplayName(item.service) }}
                  </td>

                  <td class="mat-cell-custom">
                    <input
                      type="number"
                      class="bb-input"
                      min="1"
                      [(ngModel)]="item.quantity"
                      [ngModelOptions]="{standalone: true}"
                    />
                  </td>

                  <td class="mat-cell-custom">
                    <input
                      class="bb-input"
                      type="number"
                      min="0"
                      [(ngModel)]="item.price"
                      [ngModelOptions]="{standalone: true}"
                    />
                  </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Normal Mode: Products Table -->
        <div class="bb-field bb-field-full" *ngIf="selectedProductsDetails.length > 0">
          <label class="bb-label">{{ 'Product' | transloco }}</label>

          <div class="bb-table-scroll">
            <table class="bb-table">
              <thead>
                <tr>
                  <th class="mat-header-cell-custom">{{ 'Product' | transloco }}</th>
                  <th class="mat-header-cell-custom" *ngIf="!isMobile">{{ 'quantity' | transloco }}</th>
                  <th class="mat-header-cell-custom">
                    @if(warehouseIsStore){ {{ 'Bonus' | transloco }} } @else { {{ 'price' | transloco }} }
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of selectedProductsDetails">
                  @if(isMobile){
                  <td class="mat-cell-custom">
                    <div class="bb-text-stack">
                      <div class="bb-product-title">
                        {{ 'Product' | transloco }} - {{ getProductDisplayName(item.product) }}
                      </div>

                      <input
                        type="number"
                        class="bb-input"
                        placeholder="{{ 'quantity' | transloco }}"
                        min="1"
                        [(ngModel)]="item.quantity"
                        [ngModelOptions]="{standalone: true}"
                      />
                    </div>
                  </td>
                  }@else{
                  <td class="mat-cell-custom bb-font-bold">
                    {{ 'Product' | transloco }} - {{ getProductDisplayName(item.product) }}
                  </td>

                  <td class="mat-cell-custom">
                    <input
                      type="number"
                      class="bb-input"
                      min="1"
                      [(ngModel)]="item.quantity"
                      [ngModelOptions]="{standalone: true}"
                    />
                  </td>

                  <td class="mat-cell-custom">
                    <input
                      class="bb-input"
                      type="number"
                      min="0"
                      *ngIf="!warehouseIsStore"
                      [(ngModel)]="item.price"
                      [ngModelOptions]="{standalone: true}"
                      [readonly]="!editPriceEnabled"
                      [class.readonly-input]="!editPriceEnabled"
                      [title]="!editPriceEnabled ? ('Price editing is disabled for this business' | transloco) : ''"
                    />

                    <input
                      class="bb-input"
                      placeholder="{{ 'Bonus' | transloco }}"
                      type="number"
                      min="0"
                      *ngIf="warehouseIsStore"
                      [(ngModel)]="item.bounes"
                      [ngModelOptions]="{standalone: true}"
                    />
                  </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        }

        <!-- Hidden Form Anchor -->
        <div #formElement></div>

        <!-- Submit / Update Button -->
                   <div class="bb-field bb-field-full bb-mt-16">
          @if(isUpdate){
          <button
            type="button"
            (click)="updateOrder()"
            class="bb-btn bb-btn-primary bb-btn-wide"
            [class.is-disabled]="data.invalid || hasNoSelectedItems()"
          >
            {{ "update" | transloco }}
          </button>
          }@else{
          <button
            type="submit"
            class="bb-btn bb-btn-primary bb-btn-wide"
            [class.is-disabled]="data.invalid || !hasAtLeastOneItem"
          >
            {{ "Submit" | transloco }}
          </button>
          }
        </div>
      </div>
    </form>
  </div>
</section>
